import { ServerStorage } from "@/constants/app-data";

export default function ImageSlider({
    img,
    alt,
    isPriority = false,
}: {
    img: string;
    alt: string;
    isPriority?: boolean;
}) {
    return (
        <div className="absolute bottom-0 -right-2.5 md:right-0 md:top-0 w-[55%] md:w-[60%] h-45 sm:h-55 md:h-full z-10 pointer-events-none">
            {/* MOBILE: Top and Left fade intersection */}
            <div
                className="relative w-full h-full overflow-hidden md:hidden"
                style={{
                    WebkitMaskImage:
                        "linear-gradient(to bottom, transparent, black 25%), linear-gradient(to right, transparent, black 25%)",
                    WebkitMaskComposite: "source-in",
                    maskImage:
                        "linear-gradient(to bottom, transparent, black 25%), linear-gradient(to right, transparent, black 25%)",
                    maskComposite: "intersect",
                }}>
                <img
                    src={
                        img.startsWith("/assets")
                            ? img
                            : `${ServerStorage}${img}`
                    }
                    alt={alt}
                    fetchPriority={isPriority ? "high" : "auto"}
                    loading={isPriority ? "eager" : "lazy"}
                    className="w-full h-full object-cover object-bottom scale-110 dark:filter-[brightness(0.55)_contrast(1.15)]"
                />
            </div>

            {/* DESKTOP: Left fade only */}
            <div className="relative w-full h-full overflow-hidden hidden md:block mask-[linear-gradient(to_right,transparent,black_40%)] [-webkit-mask-image:linear-gradient(to_right,transparent,black_40%)]">
                <img
                    src={
                        img.startsWith("/assets")
                            ? img
                            : `${ServerStorage}${img}`
                    }
                    alt={alt}
                    fetchPriority={isPriority ? "high" : "auto"}
                    loading={isPriority ? "eager" : "lazy"}
                    className="w-full h-full object-cover object-right scale-105 dark:filter-[brightness(0.55)_contrast(1.15)]"
                />
            </div>
        </div>
    );
}
